export default __webpack_public_path__ + "static/media/an8.588e8686.jpg";